import { render, staticRenderFns } from "./TopBarDesktop.vue?vue&type=template&id=309cf1c6&"
import script from "./TopBarDesktop.vue?vue&type=script&lang=js&"
export * from "./TopBarDesktop.vue?vue&type=script&lang=js&"
import style0 from "./TopBarDesktop.vue?vue&type=style&index=0&id=309cf1c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports